import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ScheduledEmailStatus } from '@this+that/models';
import { ScheduledMailIcon } from '@web/components/ScheduledMailIcon';

import { APP_PAGES } from '../../../../routes/constants';
import { useGetScheduledEmails } from '../../../../services/scheduledEmails.service';
import { FETCH_POLICY_CACHE_FIRST } from '../../../../utils/constants';
import { SidebarNavLink } from '../SidebarNavLink';

interface ScheduledInboxNavLinkProps {
  isOpen: boolean;
  onNavigate?: () => void;
}

export function ScheduledInboxNavLink({
  isOpen,
  onNavigate,
}: Readonly<ScheduledInboxNavLinkProps>) {
  const { t } = useTranslation();
  const { scheduledEmails } = useGetScheduledEmails(FETCH_POLICY_CACHE_FIRST);

  const pendingScheduledEmails = useMemo(() => {
    return scheduledEmails.filter(
      (scheduledEmail) =>
        scheduledEmail.status === ScheduledEmailStatus.PENDING,
    );
  }, [scheduledEmails]);

  if (pendingScheduledEmails.length === 0) {
    return null;
  }

  return (
    <SidebarNavLink
      icon={ScheduledMailIcon}
      text={t('inbox.sidebar.scheduled')}
      href={APP_PAGES.INBOX_SCHEDULED}
      isOpen={isOpen}
      count={pendingScheduledEmails.length}
      onNavigate={onNavigate}
    />
  );
}
